import { render, staticRenderFns } from "./PurchasePaymentConfirm.vue?vue&type=template&id=29215912"
import script from "./PurchasePaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports